import { useCategoriesStore, useItemsStore } from '../store';
import { Category as CategoryInterface } from '../interfaces/domain/menu';

export const useMenuActions = () => {
  const setCategorySelected = useCategoriesStore((s) => s.setCategorySelected);
  const setHasFilter = useItemsStore((s) => s.setHasFilter);

  const resetMenu = () => {
    setHasFilter(false);
    setCategorySelected(null);
  };

  const selectCategory = (category: CategoryInterface | null) => {
    if (!category || category.id === 'home-link') {
      resetMenu();
    } else {
      setHasFilter(true);
      setCategorySelected(category);
    }
  };

  return { 
    selectCategory, 
    resetMenu 
  };
};